import { render, staticRenderFns } from "./photo-uploader.vue?vue&type=template&id=7f48c292&scoped=true&"
import script from "./photo-uploader.vue?vue&type=script&lang=js&"
export * from "./photo-uploader.vue?vue&type=script&lang=js&"
import style0 from "./photo-uploader.vue?vue&type=style&index=0&id=7f48c292&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48c292",
  null
  
)

export default component.exports